'use client';

import { ComponentType, useEffect, useState } from 'react';
import { AD_SLOTS, AdSlotContext, resolveVariant } from '@/lib/adSlots';
import DiscoverCarsAd from './variants/DiscoverCarsAd';
import Stay22Ad from './variants/Stay22Ad';
import TravelpayoutsHotelsAd from './variants/TravelpayoutsHotelsAd';
import TravelpayoutsRentalCarsAd from './variants/TravelpayoutsRentalCarsAd';

const VARIANT_COMPONENTS: Record<string, ComponentType<Partial<AdSlotContext>>> = {
  discovercars: DiscoverCarsAd,
  travelpayouts_rentalcars: TravelpayoutsRentalCarsAd,
  stay22: Stay22Ad,
  travelpayouts_hotels: TravelpayoutsHotelsAd,
};

interface AdSlotProps {
  slot: string;
  className?: string;
  context?: Partial<AdSlotContext>;
}

export default function AdSlot({ slot, className = '', context = {} }: AdSlotProps) {
  const [variant, setVariant] = useState<string | null>(null);

  useEffect(() => {
    setVariant(AD_SLOTS[slot] ? resolveVariant(slot) : null);
  }, [slot]);

  if (!variant) {
    return null;
  }

  const VariantComponent = VARIANT_COMPONENTS[variant];
  if (!VariantComponent) {
    return null;
  }

  return (
    <div className={className}>
      <div className="bg-white rounded-xl shadow-lg p-6 mb-8 dark:bg-gray-800 dark:border dark:border-gray-700">
        <VariantComponent {...context} />
      </div>
    </div>
  );
}
